import { Checkbox } from "@/components/ui/checkbox";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { CustomFieldProps } from '../custom-fields-container';
import { FormLabelWithIndicator } from "../form-label-with-indicator";
import { useFormContext } from "react-hook-form";
import { useCallback } from "react";

type CustomCheckboxFieldProps = CustomFieldProps & {
}

export function CustomCheckboxField({
    control,
    name,
    label,
    description,
    showDescription,
    info,
    required,
    isValid,
    showFormMessage,
}: CustomCheckboxFieldProps) {
    
      const { trigger, setValue } = useFormContext();
    
      const handleOnChange = useCallback((value: any) => {
        console.debug('handleOnChange', name, value);
        setValue(name, value, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        trigger();
      }, [setValue, trigger, name]);
    
    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem className="">
                    <FormLabelWithIndicator label={label} isValid={isValid} required={required} info={info} />
                    <FormControl>
                        <Checkbox
                            ref={field.ref}
                            checked={field.value}
                            onCheckedChange={handleOnChange}
                        />
                    </FormControl>
                    {showDescription && (<FormDescription>{description}</FormDescription>)}
                    {showFormMessage && <FormMessage />}
                </FormItem>
            )}
        />
    )
}

